"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _toggleItem = _interopRequireDefault(require("./toggle-item"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/**
 * Local Imports
 **/

const RootContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RootContainer",
  class: "pl-rf4iwcr"
});
const SwitchContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SwitchContainer",
  class: "pl-s1g9xtbl"
});
const Notch = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Notch",
  class: "pl-n12rddyo",
  vars: {
    "n12rddyo-0": [({
      notchWidth
    }) => notchWidth]
  }
});
const SwitchWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SwitchWrapper",
  class: "pl-si8b116",
  vars: {
    "si8b116-1": [({
      hasTagText
    }) => hasTagText ? '2fr 3fr' : 'repeat(2, 1fr)'],
    "si8b116-3": [({
      hasTagText
    }) => hasTagText ? '40%' : '50%'],
    "si8b116-4": [({
      hasTagText
    }) => hasTagText ? '60%' : '50%']
  }
});
const CtaDisclaimer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaDisclaimer",
  class: "pl-c1ctolbz"
});

/**
 * SegmentToggle Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Unique id of the component
 * @param {String} props.toggleLeftText Monthly Label
 * @param {String} props.toggleRightText Yearly Label
 * @param {String} props.toggleTagText Savings Label
 * @param {Function} props.changeHandler onChange Handler
 * @param {Boolean} props.toggled toggle state
 * @param {Boolean} props.dynamicToggleSizing Toggle size is bigger if toggleTagText exists
 * @param {String} props.toggleDisclaimer Disclaimer Label
 * @returns {React.ReactElement} SegmentToggle Component
 * @public
 */

function SegmentToggle({
  id,
  toggleLeftText,
  toggleRightText,
  toggleTagText,
  changeHandler,
  toggled,
  toggleDisclaimer,
  dynamicToggleSizing = false,
  ...rest
}) {
  const notchWidth = () => toggleTagText && dynamicToggleSizing ? '40%' : '50%';
  return /*#__PURE__*/_react.default.createElement(RootContainer, (0, _extends2.default)({
    "data-cy": "switch-toggle"
  }, rest), /*#__PURE__*/_react.default.createElement(SwitchContainer, null, /*#__PURE__*/_react.default.createElement(SwitchWrapper, {
    hasTagText: toggleTagText && dynamicToggleSizing,
    role: "radiogroup"
  }, /*#__PURE__*/_react.default.createElement(_toggleItem.default, {
    id: `left-${id}`,
    value: "default",
    label: toggleLeftText,
    onChange: changeHandler,
    isSelected: !toggled,
    name: `segment-${id}`,
    _name: "switch-toggle-left"
  }), /*#__PURE__*/_react.default.createElement(_toggleItem.default, {
    id: `right-${id}`,
    value: "toggled",
    label: toggleRightText,
    tagLabel: toggleTagText,
    onChange: changeHandler,
    isSelected: toggled,
    name: `segment-${id}`,
    _name: "switch-toggle-right"
  }), /*#__PURE__*/_react.default.createElement(Notch, {
    "data-cy": "notch",
    notchWidth: notchWidth()
  }))), toggleDisclaimer && /*#__PURE__*/_react.default.createElement(CtaDisclaimer, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, {
    asType: "paragraph",
    size: -1,
    text: toggleDisclaimer
  })));
}
var _default = exports.default = SegmentToggle;
SegmentToggle.propTypes = {
  id: _propTypes.default.string,
  toggleLeftText: _propTypes.default.string,
  toggleRightText: _propTypes.default.string,
  toggleTagText: _propTypes.default.string,
  changeHandler: _propTypes.default.func,
  toggled: _propTypes.default.bool,
  dynamicToggleSizing: _propTypes.default.bool,
  toggleDisclaimer: _propTypes.default.string
};
SwitchWrapper.propTypes = {
  hasTagText: _propTypes.default.bool
};
Notch.propTypes = {
  notchWidth: _propTypes.default.string
};